import React from "react";

export const RightArrowCircleIcon = (props) => {
  return (
    <>
      <svg
        width={30}
        height={30}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx={15}
          cy={15}
          r={15}
          fill="#FAFAFA"
          style={{
            fill: "#FAFAFA",
            fill: "color(display-p3 0.9804 0.9804 0.9804)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M12.1809 21.8016C11.9616 21.5611 11.9417 21.1847 12.1211 20.9196L12.1809 20.8436L17.5086 15L12.1809 9.15643C11.9616 8.91593 11.9417 8.53959 12.1211 8.27439L12.1809 8.19841C12.4002 7.95791 12.7433 7.93605 12.9851 8.13282L13.0544 8.19841L18.8191 14.521C19.0384 14.7615 19.0583 15.1378 18.8789 15.403L18.8191 15.479L13.0544 21.8016C12.8132 22.0661 12.4221 22.0661 12.1809 21.8016Z"
          fill="#231F20"
          stroke="#231F20"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth={0.5}
        />
      </svg>
    </>
  );
};
